import { NgModule } from '@angular/core';
import { ROUTES, RouterModule } from '@angular/router';

import { AuthService } from '@app/core';

const routesFactory = (authService: AuthService) => [
    {
        path: '',
        loadChildren: () =>
            authService?.user?.isAdmin ?
                import('@modules/dashboard/modules/admin/admin-dashboard.module').then(m => m.AdminDashboardModule) :
                authService?.user?.isLeadAdmin ?
                    import('@modules/dashboard/modules/lead-admin/lead-admin-dashboard.module').then(m => m.LeadAdminDashboardModule) :
                    import('@modules/dashboard/modules/owner/owner-dashboard.module').then(m => m.OwnerDashboardModule)
    }
];

@NgModule({
    imports: [RouterModule.forChild([])],
    providers: [{
        provide: ROUTES,
        useFactory: routesFactory,
        multi: true,
        deps: [AuthService]
    }],
    exports: [RouterModule]
})
export class DashboardRoutingModule { }